import { BaseService } from "../base/BaseService";
import { ICalendarService } from "./ICalendarService";
import { ICalendar } from "./ICalendar";
import { ICalendarRepository } from "./ICalendarRepository";

export class CalendarService extends BaseService implements ICalendarService {
    private calendarRepository: ICalendarRepository;
    constructor() {
        super();
        this.calendarRepository = this.dependencies.calendarRepository
    }
    get(): Promise<ICalendar[]> {
        return this.calendarRepository.get();
    }
    getById(id: string): Promise<ICalendar | undefined> {
        return this.calendarRepository.getById(id);
    }
    save(calendars: ICalendar[]): Promise<void> {
        return this.calendarRepository.save(calendars);
    }
    delete(id: string): Promise<void> {
        return this.calendarRepository.delete(id);
    }
}
